<template>
  <footer>
    <div class="container">
      <ul @click="clickFoot" class="list-inline">
        <li class="list-inline-item">
          <router-link to="/privacy">Privacy</router-link>
        </li>
        <li class="list-inline-item">
          <router-link to="terms">Terms</router-link>
        </li>
      </ul>
      <p>Copyright &copy; {{ yearTime }} Charging Animation Show.</p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      yearTime: new Date().getFullYear()
    };
  },
  methods: {
    clickFoot() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      });
    }
  }
};
</script>

<style scoped>
/* .footer-black {
  margin-top: 1rem;
} */
.p-small {
  text-align: center;
  margin: 1rem 0 !important;
}
.list-inline-item {
  margin: 12px 24px;
}
</style>
